import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
//import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import Table from 'react-bootstrap/Table';
import isMobile from 'ismobilejs';
import './App.css';
const $ = require('jquery');

class App extends React.Component {

  componentDidMount() {
    if (!isMobile().any) {
      const targets = $(".card-header").toArray();
      targets.forEach((element, index) => {
        console.log("targets[" + index + "]: ", element);
        $(element).mouseover(() => {
          if (!$(element).next().hasClass("show")) {
            $(element).trigger("click");
          }
        });
      });
    }
  }

  render() {
    return (
      <div className="container mt-3">
        <h1 className="title">
          NUCT Hands On Workshop
          <wbr />
          <span className="d-none d-sm-inline">&nbsp;&nbsp;</span>
          <span className="smallLetter">English Edition (<a style={{display: 'inline'}} href="/studio/nuct_kousyukai/">日本語版</a>もあります)</span>
        </h1>
        <div>
          <Table bordered hover size="sm" >
            <tbody>
              <tr>
                <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/90bfe4612e6348477d4bd0a29fba49e1f4de1af8/autostart/true/caption/true">NUCT tutorial for beginners</a></td>
                <td style={{ width: "70%" }}>Video</td>
              </tr>
              <tr>
                <td style={{ width: "70%" }}><a href="https://media.itc.nagoya-u.ac.jp/studio/NUCT-tutorial-for-beginners.pdf">NUCT tutorial for beginners</a></td>
                <td style={{ width: "70%" }}>PDF</td>
              </tr>
            </tbody>
          </Table>
          <Accordion defaultActiveKey="0" style={{ marginLeft: "1em", marginTop: "1px" }}>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="0" className="scard">
                Hand-on Workshop: Online teaching and learning at NU
                </Accordion.Toggle>
              <Accordion.Collapse eventKey="0">
                <Table bordered hover size="sm" >
                  <tbody>
                    <tr>
                      <td colSpan="2" className="mtd">Handout slides</td>
                    </tr>
                    <tr>
                      <Table bordered hover size="sm" >
                        <tbody>
                          <tr>
                            <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/0c96796f40f8553313e733a4e8bac5add47e75bd/autostart/true/caption/true">Online teaching and learning at NU</a></td>
                            <td style={{ width: "70%" }}>Video</td>
                          </tr>
                          <tr>
                            <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/Online-teaching-and-learning-at-NU-HLC.pdf">Online teaching and learning at NU</a></td>
                            <td style={{ width: "70%" }}>PDF</td>
                          </tr>
                          <tr>
                            <td colSpan="2" className="mtd">Additional guides</td>
                          </tr>
                          <tr>
                            <td colSpan="2">
                              <Table bordered hover size="sm">
                                <tbody>
                                  <tr>
                                    <td style={{ width: "70%" }}><a href="https://www.uhd.edu/computing/services-training/training/Documents/zoom_record_presentations.pdf">Recording Presentations with Zoom</a></td>
                                    <td style={{ width: "70%" }}>PDF</td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "70%" }}><a href="https://support.office.com/en-us/article/record-a-slide-show-with-narration-and-slide-timings-0b9502c6-5f6c-40ae-b1e7-e47d8741161c">Record a powerpoint slide show with narration and slide timings</a></td>
                                    <td style={{ width: "70%" }}>HTML</td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "70%" }}><a href="https://support.apple.com/ja-jp/guide/keynote/tan8a5df9cc5/mac">Record audio in Keynote on Mac</a></td>
                                    <td style={{ width: "70%" }}>HTML</td>
                                  </tr>
                                </tbody>
                              </Table>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </tr>
                    <tr>
                      <td colSpan="2" className="mtd">NUCT Tutorial for Instructor</td>
                    </tr>
                    <Table bordered hover size="sm" >
                      <tbody>
                        <tr>
                          <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-instructor-1-Summary.pdf">1. Summary</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-instructor-2-Site-Info.pdf">2. Site Info</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-instructor-3-Announcements.pdf">3. Announcement</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-instructor-4-Resources.pdf">4. Resources</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-instructor-5-Assignments.pdf">5. Assignments</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-instructor-6-Test-Quizzes.pdf">6. Test and Quizzes</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-instructor-7-Gradebook.pdf">7. Gradebook</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-instructor-8-Messages.pdf">8. Messages</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                      </tbody>
                    </Table>
                    <tr>
                      <td colSpan="2" className="mtd">NUCT Tutorial for Students</td>
                    </tr>
                    <Table bordered hover size="sm" >
                      <tbody>
                        <tr>
                          <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-student-1-Summary.pdf">1. Summary</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-student-2-Site-Info.pdf">2. Site Info</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-student-3-Announcements.pdf">3. Announcement</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-student-4-Resources.pdf">4. Resources</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-student-5-Assignments.pdf">5. Assignments</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-student-6-Test-Quizzes.pdf">6. Test and Quizzes</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-student-7-Gradebook.pdf">7. Gradebook</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-student-8-Messages.pdf">8. Messages</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                      </tbody>
                    </Table>
                  </tbody>
                </Table>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>
        <div>
          <p className="text-center">Some PDF files can only be viewed from within Nagoya University. Also, some videos require Nagoya University ID authentication.</p>
        </div>
      </div>
    );
  }
}
export default App;
